export const isAnalyticsHomepageRegex = '^/(?:hosted/)?places/admin/space-analytics/?$';
